import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoPopover } from '@klareospace/pharos-lib-web-utils';

// ─── Component ────────────────────────────────────────────────────────────────

export function DriverTooltip(): React.JSX.Element {
  const { t } = useTranslation('settings');

  return (
    <InfoPopover
      ariaLabel={t('drivers.tooltip.ariaLabel')}
      description={t('drivers.tooltip.body')}
      title={t('drivers.tooltip.title')}
    />
  );
}
